import { useApiMutation } from './common/ApiCommon';

export const ApiRefundInfo = (options) => {

    const subUrl = "/refund/info";
    const successFn = options?.onSuccess || (()=>{});
    const errorFn = options?.onError || (()=>{});

    const mutation = useApiMutation(subUrl, successFn, errorFn);
    return mutation;
};

export const ApiRefundApply = (options) => {

    const subUrl = "/refund/apply";
    const successFn = options?.onSuccess || (()=>{});
    const errorFn = options?.onError || (()=>{});

    const mutation = useApiMutation(subUrl, successFn, errorFn);
    return mutation;
};